// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCollateralAgreementRequestsV2 } from '@hooks/queries/collateralv2/collateral/useCollateralAgreementRequestsV2';
import { useModuleParty } from '../../contexts/ModuleContext';

export const useInboundCollateralAgreementRequestCountV2 = () => {
  const party = useModuleParty();
  const requests = useCollateralAgreementRequestsV2();
  return requests.data?.filter((r) => r.payload.counterparty === party)?.length || 0;
};
